import { render, staticRenderFns } from "./alternateLogin.vue?vue&type=template&id=b3f9ad88&scoped=true&class=white&"
import script from "./alternateLogin.vue?vue&type=script&lang=ts&"
export * from "./alternateLogin.vue?vue&type=script&lang=ts&"
import style0 from "./alternateLogin.vue?vue&type=style&index=0&id=b3f9ad88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3f9ad88",
  null
  
)

export default component.exports